import { render, staticRenderFns } from "./answer-info.vue?vue&type=template&id=606a2c4b&scoped=true&"
import script from "./answer-info.vue?vue&type=script&lang=js&"
export * from "./answer-info.vue?vue&type=script&lang=js&"
import style1 from "./answer-info.vue?vue&type=style&index=1&id=606a2c4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606a2c4b",
  null
  
)

export default component.exports